import { render, staticRenderFns } from "./xqbianji.vue?vue&type=template&id=2de965b5&"
import script from "./xqbianji.vue?vue&type=script&lang=js&"
export * from "./xqbianji.vue?vue&type=script&lang=js&"
import style0 from "./xqbianji.vue?vue&type=style&index=0&id=2de965b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports